import { IconPropsType } from 'designSystem/types/icons';

interface IInwardArrowIconProps extends IconPropsType {}

const InwardArrowIcon = ({
  size = 20,
  color = '#000000',
  ...props
}: IInwardArrowIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_469_405)">
      <circle cx={10.5} cy={10} r={10} fill="#E45E4F" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5077 6.3953C13.1882 6.40676 12.9381 6.6854 12.9491 7.01766L13.1032 11.6635L7.59289 5.93276C7.36685 5.69767 7.00036 5.69767 6.77431 5.93276C6.54826 6.16785 6.54826 6.549 6.77431 6.78409L12.2846 12.5148L7.81749 12.3546C7.498 12.3431 7.23007 12.6032 7.21906 12.9355C7.20804 13.2677 7.4581 13.5464 7.77759 13.5578L13.7123 13.7707C13.8727 13.7764 14.0281 13.7127 14.1416 13.5947C14.255 13.4767 14.3163 13.315 14.3107 13.1483L14.1061 6.97617C14.0951 6.64391 13.8272 6.38384 13.5077 6.3953Z"
        fill="#FDFDFD"
      />
    </g>
    <defs>
      <clipPath id="clip0_469_405">
        <rect
          width={size}
          height={size}
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default InwardArrowIcon;
